import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from "rxjs";

import {
  DeliveryUnitModel, EgiSuffixModel, EgiModel, EmployeeModel, FailureCodesEgiModel, MasterTypesModel, PlaceMileageModel,
  PlaceELRModel, ReferenceTypeModel, SectionManagerTeamsModel, SignalboxDUModel, SuffixModel, TrustIdsModel, TypeIdModel, DisciplineModel, ItemStatusModel
} from '@app/models/failure/master.model';

@Injectable({ providedIn: 'root' })
export class MasterService {

  private apiUrl: string = `${environment.apiUrl}/api/master/`;
  private apiUrl_RBAC: string = `${environment.apiUrl_RBAC}`;

  constructor(private httpClient: HttpClient) { }

  getOrgHierarchyMetaData(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.apiUrl_RBAC}/references/orgHierarchyMetaData`);
  }

  getRbacOrganizationData(type: string, value: string): Observable<any> {
    let dataObj = {
      "messageContext": {
        "messageId": "1D5EB978-E26A-4653-A1FF-4109044AB053",
        "messageType": "getOrganizationData",
        "sourceApplicationType": "MWM_API",
        "sourceType": "User"
      },
      "organizationData": { "type": type, "code": value }
    }

    const headers = new HttpHeaders({ 'pageNo': '1', 'pageSize': '20000' });
    return this.httpClient.post<any>(`${this.apiUrl_RBAC}/references/organizationhierarchyData`, dataObj, { headers });
  }



  getRbacDeliveryUnits(controlcentre: string): Observable<any> {
    let dataObj = {
      "messageContext": {
        "messageId": "1D5EB978-E26A-4653-A1FF-4109044AB053",
        "messageType": "getOrganizationData",
        "sourceApplicationType": "MWM_API",
        "sourceType": "User"
      },
      "organizationData": {
        "type": "Control Center", "code": controlcentre
      }
    }
    console.log('1');
    const headers = new HttpHeaders({ 'pageNo': '1', 'pageSize': '20000' });
    return this.httpClient.post<any>(`${this.apiUrl_RBAC}/references/organizationhierarchyData`, dataObj, { headers });
  }

  public getMasterTypes(): Observable<MasterTypesModel[]> {
    const requestbody = {'mode': 1 };
    return this.httpClient.post<any[]>(`${this.apiUrl}`,requestbody, {});
}

  public getMasterReferenceValues(searchValue: any): Observable<any[]> {
    let dataObj = {
      "messageContext": {
        "messageId": "a13a2ddc-a9ef-4d72-9203-8b3d8cebce0d",
        "messageType": "Request",
        "sourceApplicationType": "API_MGMT",
        "sourceType": "System"
      },
      "referenceCode": {
        "referenceType": {
          "type": ""
        }
      }
    }
    if (searchValue.refType === 'ENG') {
      dataObj.referenceCode.referenceType.type = 'discipline';
      const headers = new HttpHeaders({ 'pageNo': '1', 'pageSize': '20000' });
      return this.httpClient.post<any[]>(`${this.apiUrl_RBAC}/references/Hierarchies`, dataObj, { headers });
    }
    else if (searchValue.refType === 'FFN') {
      dataObj.referenceCode.referenceType.type = 'Function';
      const headers = new HttpHeaders({ 'pageNo': '1', 'pageSize': '20000' });
      return this.httpClient.post<any[]>(`${this.apiUrl_RBAC}/references/Hierarchies`, dataObj, { headers });
    }
    else if (searchValue.refType === 'EFN') {
      dataObj.referenceCode.referenceType.type = 'EGI';
      const headers = new HttpHeaders({ 'pageNo': '1', 'pageSize': '20000' });
      return this.httpClient.post<any[]>(`${this.apiUrl_RBAC}/references/Hierarchies`, dataObj, { headers });
    }
    else if (searchValue.refType === 'SUF') {
      return this.httpClient.get<any[]>(`${this.apiUrl}/suffix`, {});
    }
    else if (searchValue.refType === 'PLC') {
      return this.httpClient.get<any[]>(`${this.apiUrl}/place`, {});
    }
    else {
      return this.httpClient.post<any[]>(`${this.apiUrl}`, searchValue,{});
    }
  }
  public getMasterEmployees(): Observable<EmployeeModel[]> {
    return this.httpClient.get<EmployeeModel[]>(`${this.apiUrl}/employees/`, {});
  }
  public getSignalboxByDUnit(duId: string): Observable<SignalboxDUModel[]> {
    return this.httpClient.get<SignalboxDUModel[]>(`${this.apiUrl}/signalbox/${duId}`, {});
  }
  public getEgiBySuffixId(suffixId: number): Observable<EgiSuffixModel[]> {
    return this.httpClient.get<EgiSuffixModel[]>(`${this.apiUrl}/egi/${suffixId}`, {});
  }
  public getEgiByDisipline(discipline: string): Observable<EgiModel[]> {
    return this.httpClient.get<EgiModel[]>(`${this.apiUrl}/egiByDiscipline/${discipline}`, {});
  }
  public getDisipline(): Observable<DisciplineModel[]> {
    return this.httpClient.get<DisciplineModel[]>(`${this.apiUrl}/discipline`);
  }
  public getDisiplineByEgi(egi: string): Observable<DisciplineModel[]> {
    return this.httpClient.get<DisciplineModel[]>(`${this.apiUrl}/disciplineByEgi/${egi}`);
  }
  public getSuffixByEgiId(egiId: string): Observable<EgiSuffixModel> {
    return this.httpClient.get<EgiSuffixModel>(`${this.apiUrl}/suffix/${egiId}`, {});
  }
  public getProblemCodesByEgiId(egiId: string): Observable<FailureCodesEgiModel[]> {
    return this.httpClient.get<FailureCodesEgiModel[]>(`${this.apiUrl}/problemCodes/${egiId}`, {});
  }
  public getMasterReferenceType(): Observable<ReferenceTypeModel[]> {
    return this.httpClient.get<ReferenceTypeModel[]>(`${this.apiUrl}/referenceType/`, {});
  }
  public getDeliveryUnitByIfcId(ifcId: number): Observable<DeliveryUnitModel[]> {
    return this.httpClient.get<DeliveryUnitModel[]>(`${this.apiUrl}/deliveryUnit/${ifcId}`, {});
  }
  public getPlacesAndElrByIfcId(ifcId: number, gisView: boolean): Observable<PlaceELRModel[]> {
    let place = gisView ? 'placesAndElrsGIS' : 'placesAndElrs';
    return this.httpClient.get<PlaceELRModel[]>(`${this.apiUrl}/${place}/${ifcId}`, {});
  }
  public getSectionMaTByDUnit(routeName: string): Observable<SectionManagerTeamsModel[]> {
    return this.httpClient.get<SectionManagerTeamsModel[]>(`${this.apiUrl}/sectionManagerAndTeams/${routeName}`, {});
  }
  public getSuffix(): Observable<SuffixModel[]> {
    return this.httpClient.get<SuffixModel[]>(`${this.apiUrl}/suffix`, {});
  }
  public getEgi(): Observable<EgiModel[]> {
    return this.httpClient.get<EgiModel[]>(`${this.apiUrl}/egi`, {});
  }
  public getPlaceMileage(searchValue: any): Observable<PlaceMileageModel> {
    return this.httpClient.post<PlaceMileageModel>(`${this.apiUrl}/placeMileage`, searchValue,{});
  }
  public getTrustIds(searchValue: any): Observable<TrustIdsModel[]> {
    const headers = new HttpHeaders({ 'X-Trust-ID-Filters': JSON.stringify(searchValue) });
    return this.httpClient.get<TrustIdsModel[]>(`${this.apiUrl}/delayIds`, { headers });
  }
  public getSymptomBySuffixId(suffixId: any): Observable<TypeIdModel[]> {
    return this.httpClient.get<TypeIdModel[]>(`${this.apiUrl}/symptom/suffix/${suffixId}`, {});
  }
  public getPlace(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.apiUrl}/place`, {});
  }
  public getElr(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.apiUrl}/elr`, {});
  }
  public getItemStatus(): Observable<ItemStatusModel[]> {
    return this.httpClient.get<ItemStatusModel[]>(`${this.apiUrl}/itemStatus`, {});
  }
}
